import React from "react";
import {Container, Navbar, Nav, Dropdown} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import "../css/SideBarMenuOne.css";

const SideBarMenuOne = ({genres}) => {
    const location = useLocation();
    return (
        <Navbar expand="xxl" className="navbar-custom">
            <Container fluid className="navbar-container">
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className="navbar-toggle"
                    style={{background: "white"}}
                />
                <Navbar.Collapse
                    id="basic-navbar-nav"
                    className="navbar-collapse-custom"
                >
                    <Nav className="me-auto">
                        <Nav.Item className="nav-item-first"></Nav.Item>
                        <Nav.Item className="nav-item-spacing">
                            <Link to={`/view-more/book`} className="nav-link-custom">
                                All Books
                            </Link>
                        </Nav.Item>
                        {genres.map((genre) => {
                            const displayGenre = genre.replace(/([a-z])([A-Z])/g, '$1 $2');
                            return (
                                <Nav.Item key={genre} className="nav-item-spacing">
                                    <Link
                                        to={`/genre-based-books/${genre}`}
                                        style={{color: "#fff", textDecoration: "none"}}
                                    >
                                        {displayGenre}
                                    </Link>
                                </Nav.Item>
                            );
                        })}
                    </Nav>
                    {location.pathname !== "/request" && (
                        <Nav.Item className="nav-item-spacing">
                            <Link to="/request" className="nav-link-custom">
                                Request Book
                            </Link>
                        </Nav.Item>
                    )}
                    <Dropdown style={{backgroundColor: "#3c3c3c"}}>
                        <Dropdown.Toggle variant="light" id="dropdown-your-story" className="nav-link-custom"
                                         style={{backgroundColor: "#3c3c3c", border: "none", color: "white"}}>
                            Your Story
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to="/story">
                                Create Story
                            </Dropdown.Item>
                            <Dropdown.Item as={Link} to="/storys">
                                Your Stories
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default SideBarMenuOne;
